import PropTypes from 'prop-types';
import React from 'react';
import Backdrop from 'root/components/molecules/Backdrop';

import { StyledOption, StyledOptionsMenu } from './styles';

const OptionsMenu = ({
  targetRef,
  showOnMobile,
  className,
  onClose,
  transition,
  options,
  ...props
}) => {
  return (
    <>
      <Backdrop onClick={onClose} />
      <StyledOptionsMenu
        className={className}
        showOnMobile={showOnMobile}
        targetRef={targetRef}
        transition={transition}
        {...props}
      >
        {options.map(({ text, onClick, errorStyle = false }) => (
          <StyledOption
            data-test-id="d364cc61-bf49-4a76-97c2-52ed7771cb0f"
            errorStyle={errorStyle}
            key={text}
            onClick={onClick}
          >
            {text}
          </StyledOption>
        ))}
      </StyledOptionsMenu>
    </>
  );
};

OptionsMenu.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      errorStyle: PropTypes.bool,
      onClick: PropTypes.func.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ),
  showOnMobile: PropTypes.bool,
  targetRef: PropTypes.oneOfType([
    // Either a function
    PropTypes.func,
    // Or the instance of a DOM native element (see the note about SSR)
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
  transition: PropTypes.string.isRequired,
};

OptionsMenu.defaultProps = {
  className: '',
  options: [],
  showOnMobile: true,
};

export default OptionsMenu;
